import { render } from "./MobileSubscription.vue?vue&type=template&id=8515c72a&ts=true"
import script from "./MobileSubscription.vue?vue&type=script&lang=ts"
export * from "./MobileSubscription.vue?vue&type=script&lang=ts"

import "./MobileSubscription.vue?vue&type=style&index=0&id=8515c72a&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__